export default __webpack_public_path__ + "static/media/loading.ecba0f85.gif";